import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim();
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim();
const supabaseLegacyAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();
const supabaseClientKey = supabasePublishableKey || supabaseLegacyAnonKey;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseClientKey);

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl!, supabaseClientKey!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;

export function requireSupabase() {
  if (!supabase) {
    throw new Error(
      "Supabase не настроен. Заполните VITE_SUPABASE_URL и VITE_SUPABASE_PUBLISHABLE_KEY.",
    );
  }
  return supabase;
}
